import {EwBillersActions, EwBillersData} from './types'

export const getEwBillers = (): EwBillersActions => ({
  type: "REQUEST_EWBILLERS",
});

export const getEwBillersFailed = (): EwBillersActions => ({
  type: "REQUEST_EWBILLERS_FAILED",
});

export const getEwBillersSuccess = (payload: EwBillersData): EwBillersActions => ({
  type: "REQUEST_EWBILLERS_SUCCESS",
  payload,
});
